import { useEditorStore } from '@/features/editor/stores/editor-store'
import { EDITOR_MANUAL_URL } from '@/features/editor/lib/manual'
import { cn } from '@/lib/utils'
import { SectionCard } from './section-card'

export function FirstMessageSection() {
  const firstMessage = useEditorStore((s) => s.draft.firstMessage)
  const patchDraft = useEditorStore((s) => s.patchDraft)

  const length = firstMessage.length

  return (
    <SectionCard
      title='首条消息'
      description={
        <>
          玩家进入您的世界时看到的第一段文字，即玩家进入游戏世界的初始场景。具体使用方法请参考
          <a
            href={EDITOR_MANUAL_URL}
            target='_blank'
            rel='noreferrer'
            className='text-primary underline-offset-4 hover:underline'
          >
            “使用详解”
          </a>
          。
        </>
      }
    >
      <div className='space-y-2'>
        <textarea
          className={cn(
            'bg-background border-border placeholder:text-muted-foreground',
            'min-h-[140px] w-full resize-none rounded-lg border px-3 py-3 text-sm leading-relaxed transition outline-none',
            'hover:bg-background/80',
            'focus-visible:border-ring focus-visible:ring-ring/30 focus-visible:ring-2'
          )}
          value={firstMessage}
          onChange={(e) => patchDraft({ firstMessage: e.target.value })}
          placeholder='您必须填写“首条消息”，否则游戏无法启动。您可以通过“预览”快速获得。'
        />

        {/* 字符数提示（外置、右对齐，保持统一） */}
        <div className='text-muted-foreground text-right text-xs'>
          字符：{length}
        </div>
      </div>
    </SectionCard>
  )
}
